import React, { useState } from "react"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import "../../../assets/css/Staff/Staff.css"
import {
  Container,
  Row,
  Col,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"

// components
// import LinkedinAccounts from "./LinkedinAccounts"
import LinkedinAssignees from "./LinkedinAssignees"

const LinkedinIndex = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")

  document.title = "LinkedIn | Zithas Crm"

  return (
    <React.Fragment>
      <div className="page-content mb-4">
        <Container fluid>

          <Row className="gx-4 justify-content-between di-flex align-items-top">
            <Col md="12" className="pe-0">
              <div className="card" style={{marginTop: "-160px"}}>
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted p-4 mt-0"
                >
                  <TabPane tabId="1">
                    <LinkedinAssignees />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default LinkedinIndex
